import { Endereco } from '@usucampeao/interfaces';
import { ProjetoTipo } from '..';
import { ProjetoEndereco } from './projeto-endereco.model';
import { ProjetoModalidadeType } from './projeto-modalidade.enum';
import { ProjetoStatus } from './projeto-status.enum';
import { ProjetoVendaStatus } from './projeto-venda-status.enum';
export class ProjetoDto {
  id: string;
  nome: string;
  descricao?: string;
  modalidade?: ProjetoModalidadeType;
  averbacao?: boolean;
  imagem: string;
  localizacao: Endereco;
  tipo: ProjetoTipo;
  cadastroDataInicio: Date;
  cadastroDataFim: Date;
  preAnaliseDataInicio: Date;
  preAnaliseDataFim: Date;
  escritorioDataInicio: Date;
  escritorioDataFim: Date;
  escritorioLocal: ProjetoEndereco;
  visitaDataInicio: Date;
  visitaDataFim: Date;
  prefeituraDataInicio: Date;
  prefeituraDataFim: Date;
  cartorioDataInicio: Date;
  cartorioDataFim: Date;
  matriculaDataInicio: Date;
  matriculaDataFim: Date;
  assembleiaLocal: ProjetoEndereco;
  assembleiaData: Date;
  vendaStatus: ProjetoVendaStatus;
  loteQuantidade: number;
  quadraQuantidade: number;
  dataCriacao: Date;
  usuarioCriacaoId: string;
  dataAtualizacao: Date;
  usuarioAtualizacaoId: string;
  status: ProjetoStatus;
}
